module.exports = function getResource(label, vars = []) {
    let resources = {
        item: 'Item',
        price: 'Price',
        qty: 'Qty',
        amount: 'Amount',
        oosItems: 'Out of Stock Items',
        readyForPickup: 'Items Ready for Pickup',
        pickedUpItems: 'Picked Up Items',
        canceledItems: 'Unavailable or Canceled Items'
    };

    return resources[label];
};
